import { EmailToPatient, PatientControllerApi } from "../../../services";
import { getConfigObject, useMutationWithLoading } from "../../../utils/utils";

/**
 * @author Rajkumar Rathod
 */
export const useEmailSend = () =>
  useMutationWithLoading(
    async (param: { emailToPatient: EmailToPatient; xTENANTID?: string }) =>
      new PatientControllerApi(getConfigObject()).sendEmailToPatientId(
        param?.emailToPatient,
        param?.xTENANTID
      )
  );
